
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Autocomplete, Button, Grid, TextField } from "@mui/material"
import { useQueryClient } from "@tanstack/react-query";
import { useCiudadesStore } from "../../../../store";
import { startSavingEncubadora } from "../../../../services";

import Swal from "sweetalert2";





export const FormCreateUpdateIncubadora = ({ initialState }) => {


    const { id } = useParams();
    const queryClient = useQueryClient();
    const { startListadoCiudades, ciudades, startListadoRegiones, regiones } = useCiudadesStore();
    
    

    useEffect(() => {
        startListadoRegiones();
    }, [])



    const [formEncubadora, setFormEncubadora] = useState( initialState );
    const { nombre, telefono, nit, direccion, email, ciudad, departamento } = formEncubadora;
    const  handleInputChange = ({ target }) => {
        setFormEncubadora({
            ...formEncubadora,
            [target.name]: target.value
        });
    }



    const handleChangeRegion = async (nombre) => {
        await startListadoCiudades(nombre);
        setFormEncubadora(prev => ({ ...prev, departamento: nombre })); 
    };

    
    
    const crearActInformacion = async(e) => {
        e.preventDefault();
        if([nombre, telefono, nit, direccion, email, ciudad, departamento].includes('') ){
            return Swal.fire('Error', 'Formulario Incorrecto por favor llene todos los campos', 'error');
        }

        const result = await Swal.fire({
            title: `${(id) ? 'Actualizar' : 'Crear'} Incubadora`,
            text: `¿Esta seguro de ${(id) ? 'Actualizar' : 'Crear'} Incubadora?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Si ${(id) ? 'Actualizar' : 'Crear'}`,
            cancelButtonText: 'Cancelar'
        });

        if (!result.isConfirmed) return;

        const resp = await startSavingEncubadora({...formEncubadora, id});
        if(resp){
            if(!id) { 
                setFormEncubadora( initialState ); 
            }else {
                queryClient.invalidateQueries({ queryKey: ['incubadora-id', id] });
            }
            queryClient.invalidateQueries({queryKey: ['encubadora-list']});
        }
    }



    return (

        <form onSubmit={ crearActInformacion } >
            <Grid container spacing={ 2 }>
                <Grid item xs={12} sm={6} >
                    <TextField required
                        label='Nombre'
                        type='text'                                                 
                        placeholder='Nombre'
                        fullWidth                                               
                        name='nombre'
                        value={ nombre }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Email'
                        type='email'
                        placeholder='Email'
                        fullWidth
                        name='email'
                        value={ email }
                        onChange={ handleInputChange }
                    />
                </Grid> 

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Nit'
                        type='text'
                        placeholder='Nit'
                        fullWidth
                        name='nit'
                        value={ nit }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Telefono'
                        type='text'
                        placeholder='Telefono'
                        fullWidth
                        name='telefono'
                        value={ telefono }
                        onChange={ handleInputChange }
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField required
                        label='Direccion'
                        type='text' 
                        placeholder='Direccion'
                        fullWidth
                        name='direccion'
                        value={ direccion }
                        onChange={ handleInputChange }
                    />
                </Grid>

                {(regiones.length > 0) &&
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        name='departamento'
                        value={ regiones?.find(p => p.id === departamento) || null }
                        options={ regiones || [] }
                        onChange={(_, newValue) => handleChangeRegion(newValue.id)}
                        renderInput={(params) => <TextField autoComplete="off" {...params} label='Departamento' />}
                        getOptionLabel={(option) => option.name }
                        placeholder="Departamento"
                    />
                </Grid>
                }

                {(ciudades.length > 0) &&
                <Grid item xs={12} sm={6}>
                    <Autocomplete
                        name='ciudad'
                        value={ ciudades?.find(p => p.id === ciudad) || null }
                        options={ ciudades || [] }
                        onChange={(_, newValue) => handleInputChange({ target:{name: 'ciudad', value: newValue.id || ''}})}
                        renderInput={(params) => <TextField autoComplete="off" {...params} label='Ciudad' />}
                        getOptionLabel={(option) => option.name }
                        placeholder="Ciudad"
                    />
                </Grid>
                }
            </Grid>

            <Grid container sx={{ my:4 }} direccion='column' justifyContent='center'>
                <Grid item xs={ 12 } sm={ 8 } >
                    <Button variant='contained' fullWidth type='submit'>
                        {`${id ? 'Actualizar' : 'Crear'} Incubadora`}
                    </Button>
                </Grid>
            </Grid>
        </form>

    )
}
